import { createFileRoute } from '@tanstack/react-router'

import { loadUserCrumb, useLateUserCrumb } from '@/app/user-crumb'
import { AffiliateDetailPage } from '@/features/affiliates/affiliate-detail'

export const Route = createFileRoute('/_app/affiliates/$userId')({
    // The affiliate page reads its owner through the same user query, so this is the
    // same warm cache, named after the person who owns the code.
    loader: loadUserCrumb,
    component: AffiliateRoute,
    staticData: { crumb: 'Affiliate' }
})

function AffiliateRoute() {
    const { userId } = Route.useParams()
    useLateUserCrumb(Route.id, userId, Route.useLoaderData().crumb)
    return <AffiliateDetailPage userId={userId} />
}
